import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutOriginDestinationRateTable extends Layout {
    buttonAdd: Button;
    buttonAdjustRate: Button;
    buttonSearch: Button;
    panelSecondaryFilters: Panel;
    sourceOriginDestinationRate: DataSource;
    tableRates: Table;
}
